/*
 * <cdx-facet-search> – search field above long brand/vendor filter lists (snippets/collection-filters.liquid).
 * Filters the visible options client-side; its input never reaches <facet-filters-form>, so typing
 * doesn't trigger a filter request.
 */
if (!customElements.get("cdx-facet-search")) {
  customElements.define(
    "cdx-facet-search",
    class CdxFacetSearch extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector("input");
        this.list = this.closest(".facet-content")?.querySelector(".facet-options-list");
        if (!this.input || !this.list) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.addEventListener(
          "input",
          (event) => {
            event.stopPropagation();
            this.filter();
          },
          { signal }
        );
        this.addEventListener("change", (event) => event.stopPropagation(), { signal });
        this.input.addEventListener(
          "keydown",
          (event) => {
            if (event.key === "Enter") event.preventDefault();
          },
          { signal }
        );

        if (this.input.value) this.filter();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      filter() {
        const term = this.input.value.toLowerCase().trim();
        this.list.querySelectorAll(".facet-options-list-item").forEach((item) => {
          const label = item.querySelector(".checkbox-facet-label-text");
          if (label) item.classList.toggle("hidden-by-search", !label.textContent.toLowerCase().includes(term));
        });
      }
    }
  );
}
